export default __webpack_public_path__ + "assets/img/icon-modify-on.52cb5741df8f820d17a9cd83ee18c8c9.svg";